const Footer = () => {
  return (
    <>
      <section id="contact-us" className="section-padding">
        <div className="container text-center">
          <div className="row">
            <div
              className="col-md-4 mb-sm-30 wow fadeIn"
              data-wow-delay="0.2s"
              data-wow-duration="2s"
            >
              <div className="alt-icon-sm-top">
                <i className="icon icon-basic-geolocalize-05" />
              </div>
              <h5 className="features-title">Address</h5>
              <p>
                96, Upper Ground Floor, Pkt B, Sector 26, Rohini, Rohini Sec-11,
                North West Delhi, Delhi, Delhi, India, 110085
              </p>
            </div>
            <div
              className="col-md-4 mb-sm-30 wow fadeIn"
              data-wow-delay="0.4s"
              data-wow-duration="2s"
            >
              <div className="alt-icon-sm-top">
                <i className="icon icon-basic-alarm" />
              </div>
              <h5 className="features-title">office Hours</h5>
              <p>Mon - Sat : 10am to 6:30pm</p>
            </div>
            <div
              className="col-md-4 mb-sm-30 wow fadeIn"
              data-wow-delay="0.6s"
              data-wow-duration="2s"
            >
              <div className="alt-icon-sm-top">
                <i className="icon icon-basic-headset" />
              </div>
              <h5 className="features-title">Contact</h5>
              <p className="contact-link">
                <a href="mailto:info@sarentu.com">
                  <span className="text-bold">Email :</span> info@sarentu.com
                </a>
                <br />
                <a href="tel:+919958920231">
                  <span className="text-bold">Call :</span> +91-9958-920-231
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
      <footer
        id="footer"
        className="footer section-padding"
        style={{ borderTop: "2px solid #efefef" }}
      >
        <div className="container text-center">
          <div
            className="footer-logo mb-25 wow fadeInUp"
            data-wow-duration="1.5s"
          >
            <a className="scroll-top" href="#intro">
              <img src="/img/logo-dark.jpg" alt="mazel" />
            </a>
          </div>

          <p className="copyright mb-25" style={{ textAlign: "center" }}>
            Copyright © 2024 - {new Date().getFullYear()}, Sarentu IT Solutions
            Pvt Ltd
            <br />
            <br />
            <b>CIN</b>: U62099DL2024PTC439274
            <br />
            <b>MSME</b>: UDYAM-DL-06-0144810 <br />
            <b>Startup India</b>: DIPP187476
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
